import ACTION from "../../config/contants/action";

const changeLanguage = (lang) => {
  return {
    type: ACTION.CHANGE_LANGUAGE,
    payload: lang,
  };
};

export default changeLanguage;